/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MedWheelchairIcon16Light } from './MedWheelchairIcon16Light';
import { MedWheelchairIcon16Regular } from './MedWheelchairIcon16Regular';
import { MedWheelchairIcon16Solid } from './MedWheelchairIcon16Solid';
import { MedWheelchairIcon20Light } from './MedWheelchairIcon20Light';
import { MedWheelchairIcon20Regular } from './MedWheelchairIcon20Regular';
import { MedWheelchairIcon20Solid } from './MedWheelchairIcon20Solid';
import { MedWheelchairIcon24Regular } from './MedWheelchairIcon24Regular';
import { MedWheelchairIcon24Solid } from './MedWheelchairIcon24Solid';
import { MedWheelchairIcon32Regular } from './MedWheelchairIcon32Regular';
import { MedWheelchairIcon64Regular } from './MedWheelchairIcon64Regular';
var sizes = {
    16: {
        light: MedWheelchairIcon16Light,
        regular: MedWheelchairIcon16Regular,
        solid: MedWheelchairIcon16Solid,
    },
    20: {
        light: MedWheelchairIcon20Light,
        regular: MedWheelchairIcon20Regular,
        solid: MedWheelchairIcon20Solid,
    },
    24: {
        regular: MedWheelchairIcon24Regular,
        solid: MedWheelchairIcon24Solid,
    },
    32: {
        regular: MedWheelchairIcon32Regular,
    },
    64: {
        regular: MedWheelchairIcon64Regular,
    },
};
export var MedWheelchairIcon = forwardRef('MedWheelchairIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
